import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const apiSlice = createApi({
    reducerPath: "todos",
    baseQuery: fetchBaseQuery({ baseUrl: "https://video-server-ar.herokuapp.com/todos" }),
    endpoints: builder => ({
        getInCompletedTodos: builder.query({
            query: (filterBy = []) => {
                const query = filterBy.map(color => `color=${color}`);
                query.push("completed=false");
                const queryString = query.join("&");
                return `?${queryString}`
            },
            providesTags: ["inCompletedTodoList"],
        }),
        getCompletedTodos: builder.query({
            query: (filterBy = []) => {
                const query = filterBy.map(color => `color=${color}`);
                query.push("completed=true");
                const queryString = query.join("&");
                return `?${queryString}`
            },
            providesTags: ["completedTodoList"],
        }),
        addTodo: builder.mutation({
            query: (body) => ({
                url: "",
                method: "POST",
                body
            }),
            invalidatesTags: ["inCompletedTodoList"],
        }),
        updateTodo: builder.mutation({
            query: ({ id, body }) => ({
                url: `/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["inCompletedTodoList"],
        }),
        toggleTodoStatus: builder.mutation({
            query: ({ id, body }) => ({
                url: `/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: ["inCompletedTodoList", "completedTodoList"],
        }),
        deleteInCompletedTodo: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["inCompletedTodoList"],
        }),
        deleteCompletedTodo: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["completedTodoList"],
        })
    }),
})

export const {
    useGetInCompletedTodosQuery,
    useGetCompletedTodosQuery,
    useUpdateTodoMutation,
    useToggleTodoStatusMutation,
    useDeleteInCompletedTodoMutation,
    useDeleteCompletedTodoMutation,
    useAddTodoMutation,
} = apiSlice;